import { BiChevronDown } from "react-icons/bi";
import {
  MdSpaceDashboard,
  MdKeyboardArrowRight,
  MdKeyboardArrowLeft,
  MdCheckCircle,
} from "react-icons/md";
import { GoOrganization, GoPerson, GoGear, GoSignOut } from "react-icons/go";
import {
  HiMenuAlt2,
  HiUserGroup,
  HiOfficeBuilding,
  HiOutlineDotsHorizontal,
} from "react-icons/hi";
import { CgProfile } from "react-icons/cg";
import { GiOrganigram } from "react-icons/gi";
import {
  RiDeleteBin6Line,
  RiArrowDropLeftLine,
  RiArrowDropRightLine,
  RiCloseCircleFill,
} from "react-icons/ri";
import {
  FiEdit,
  FiXCircle,
  FiPlusCircle,
  FiPlusSquare,
  FiXSquare,
  FiActivity,
  FiMenu,
  FiSearch,
  FiX,
} from "react-icons/fi";
import {
  FaBuilding,
  FaClipboardList,
  FaHandshake,
  FaUserCheck,
  FaUserTimes,
  FaUserEdit,
  FaUsers,
  FaUserClock,
  FaUser,
  FaUnlock,
  FaKey,
  FaFileExport,
  FaCheck,
  FaUserTie,
} from "react-icons/fa";
import {
  IoDocumentText,
  IoCaretDownOutline,
  IoCaretUpOutline,
  IoFilter,
  IoDocumentAttach,
  IoCalendar,
  IoImageOutline,
} from "react-icons/io5";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlinePlus,
  AiFillDatabase,
  AiOutlineInfoCircle,
  AiFillCloseSquare,
  AiFillCloseCircle,
  AiFillPlusSquare,
  AiFillPlusCircle,
  AiFillEye,
  AiFillEyeInvisible,
  AiFillCamera,
  AiTwotoneApi,
} from "react-icons/ai";

export const icons = {
  aitwotoneapi: <AiTwotoneApi />,
  fausertie: <FaUserTie />,
  riclosecirclefill: <RiCloseCircleFill />,
  mdcheckcircle: <MdCheckCircle />,
  facheck: <FaCheck />,
  fafileexport: <FaFileExport />,
  fakey: <FaKey />,
  bichevrondown: <BiChevronDown />,
  mdspacedashboard: <MdSpaceDashboard />,
  mdkeyboardarrowright: <MdKeyboardArrowRight />,
  mdkeyboardarrowleft: <MdKeyboardArrowLeft />,
  goorganization: <GoOrganization />,
  goperson: <GoPerson />,
  gogear: <GoGear />,
  gosignout: <GoSignOut />,
  himenualt2: <HiMenuAlt2 />,
  hiusergroup: <HiUserGroup />,
  hiofficebuilding: <HiOfficeBuilding />,
  hioutlinedotshorizontal: <HiOutlineDotsHorizontal />,
  cgprofile: <CgProfile />,
  giorganigram: <GiOrganigram />,
  rideletebin6line: <RiDeleteBin6Line />,
  riarrowdropleftline: <RiArrowDropLeftLine />,
  riarrowdroprightline: <RiArrowDropRightLine />,
  fiactivity: <FiActivity />,
  fimenu: <FiMenu />,
  fiedit: <FiEdit />,
  fisearch: <FiSearch />,
  fixcircle: <FiXCircle />,
  fiplussquare: <FiPlusSquare />,
  fixsquare: <FiXSquare />,
  fipluscircle: <FiPlusCircle />,
  fix: <FiX />,
  fabuilding: <FaBuilding />,
  faclipboardlist: <FaClipboardList />,
  fahandshake: <FaHandshake />,
  fausercheck: <FaUserCheck />,
  fausertimes: <FaUserTimes />,
  fauseredit: <FaUserEdit />,
  fausers: <FaUsers />,
  fauserclock: <FaUserClock />,
  fauser: <FaUser />,
  faunlock: <FaUnlock />,
  iodocumenttext: <IoDocumentText />,
  iocaretdownoutline: <IoCaretDownOutline />,
  iocaretupoutline: <IoCaretUpOutline />,
  iofilter: <IoFilter />,
  iodocumentattach: <IoDocumentAttach />,
  iocalendar: <IoCalendar />,
  ioimageoutline: <IoImageOutline />,
  aioutlinearrowleft: <AiOutlineArrowLeft />,
  aioutlinearrowright: <AiOutlineArrowRight />,
  aioutlineplus: <AiOutlinePlus />,
  aifilldatabase: <AiFillDatabase />,
  aioutlineinfocircle: <AiOutlineInfoCircle />,
  aifillplussquare: <AiFillPlusSquare />,
  aifillclosesquare: <AiFillCloseSquare />,
  aifillclosecircle: <AiFillCloseCircle />,
  aifillpluscircle: <AiFillPlusCircle />,
  aifilleye: <AiFillEye />,
  aifilleyeinvisible: <AiFillEyeInvisible />,
  aifillcamera: <AiFillCamera />,
};
